import script from "./Radio.vue?vue&type=script&lang=ts&setup=true"
export * from "./Radio.vue?vue&type=script&lang=ts&setup=true"

import "./Radio.vue?vue&type=style&index=0&id=f6d0ac26&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f6d0ac26"]])

export default __exports__